// search templates both [ default , dropdown]
// import SidebarBlock from '../block/sidebarBlock';
import CheckBoxPreview from '../search/default/checkboxpreview';
import LinearCheckBoxPreview from '../search/default/linearcheckboxpreview';
import linearcheckboxdroppreview from '../search/default/linearcheckboxpreview';
import CheckBoxDropdownPreview from '../search/dropdown/checkboxdropdownpreview';
import RadioBoxPreview from '../search/default/radioboxpreview';
import RadioBoxDropdownPreview from '../search/dropdown/radioboxdropdownpreview';
import SelectBoxPreview from '../search/default/selectboxpreview';
import SelectBoxDropdownPreview from '../search/dropdown/selectboxdropdownpreview';
import SizeBoxPreview from '../search/default/sizeboxpreview';
import SizeBoxDropdownPreview from '../search/dropdown/sizeboxdropdownpreview';
import TextBoxPreview from '../search/default/textboxpreview';
import TextBoxDropdownPreview from '../search/dropdown/textboxdropdownpreview';
import TagsPreview from '../search/default/tagspreview';
import TagsDropdownPreview from '../search/dropdown/tagsdropdownpreview';
import ImageSelectPreview from '../search/default/imageselectpreview';
import ImageSelectDropdownPreview from '../search/dropdown/imageselectdropdownpreview';
import RangeInputPreview from '../search/default/rangeinputpreview';
import RangeInputDropdownPreview from '../search/dropdown/rangeinputdropdownpreview';
import ScrollTabPreview from '../search/default/scrolltabpreview';
import ScrollTabDropdownPreview from '../search/dropdown/scrolltabdropdownpreview';
import ColorBoxPreview from '../search/default/colorboxpreview';
import ColorBoxDropdownPreview from '../search/dropdown/colorboxdropdownpreview';
import ComboBoxPreview from '../search/default/comboboxpreview';
import ComboBoxDropdownPreview from '../search/dropdown/comboboxdropdownpreview';
import MapFieldPreview from '../search/default/mapfieldpreview';
import MapFielddropdownPreview from '../search/dropdown/mapfielddropdownpreview';
import ResetButtonPreview from '../search/default/resetbuttonpreview';
import ResetButtonDropdownPreview from '../search/dropdown/resetbuttondropdownpreview';
import DateRangePicker from '../search/default/daterangepickerpreview';
import SideBar from '../search/default/sidebarpreview';
import SideBarDropdownPreview from '../search/default/sidebarpreview';
import DateRangePickerDropdownPreview from '../search/dropdown/daterangepickerdropdownpreview';
import SortingOption from '../block/bar/sortingOption';
import LoadMoreOption from '../block/bar/loadMoreOption';
import SearchAttributeShow from '../block/bar/searchAttribute';
import ViewChanger from '../block/bar/viewChanger';
import WidgetRenderBlock from '../block/widgetRenderBlock';
import MapRenderBlock from '../block/mapRenderBlock';
import ReactivePagination from '../../element/customPagination';
import CategoryLoadMore from '../block/bar/categoryLoadMore';
import MapRadiusPreview from '../search/default/mapRadiusPreview';
import IsotopeBar from '../block/bar/isotopeBar';
import RnbDatePickerPreview from '../search/default/daterangepickerpreview';
import RnbDatePickerDropDownPreview from '../search/dropdown/daterangepickerdropdownpreview';

window.ReactiveTheme['reactive'] = {
  search: {
    default: [],
    dropdown: [],
  },
  bar: {
    topbarPagniation: ReactivePagination, // direct component
    sorting: SortingOption,
    viewChanger: ViewChanger,
    searchAttributeShow: SearchAttributeShow,
    bottombarPagination: ReactivePagination,
    bottomLoadMore: LoadMoreOption,
    categoryLoadMore: CategoryLoadMore,
    isotopBar: IsotopeBar,
  },
  map: MapRenderBlock,
  widget: WidgetRenderBlock,
  name: 'Reactive',
};

// map , widget, title, url api

window.ReactiveTheme.reactive.search.default.push({
  type: 'checkbox',
  component: CheckBoxPreview,
}, {
  type: 'radio',
  component: RadioBoxPreview,
}, {
  type: 'imageselect',
  component: ImageSelectPreview,
}, {
  type: 'select',
  component: SelectBoxPreview,
}, {
  type: 'sizebox',
  component: SizeBoxPreview,
}, {
  type: 'colorbox',
  component: ColorBoxPreview,
}, {
  type: 'scrollbox',
  component: ScrollTabPreview,
}, {
  type: 'text',
  component: TextBoxPreview,
}, {
  type: 'combobox',
  component: ComboBoxPreview,
}, {
  type: 'tag',
  component: TagsPreview,
}, {
  type: 'rangeinput',
  component: RangeInputPreview,
}, {
  type: 'mapsearch',
  component: MapFieldPreview,
}, {
  type: 'reset',
  component: ResetButtonPreview,
}, {
  type: 'daterange',
  component: DateRangePicker,
}, {
  type: 'sidebar',
  component: SideBar,
}, {
  type: 'mapradius',
  component: MapRadiusPreview,
}, {
  type: 'linearcheckbox',
  component: LinearCheckBoxPreview,
}, {
  type: 'rnb-daterange',
  component: RnbDatePickerPreview,
});

window.ReactiveTheme.reactive.search.dropdown.push({
  type: 'checkbox',
  component: CheckBoxDropdownPreview,
}, {
  type: 'radio',
  component: RadioBoxDropdownPreview,
}, {
  type: 'select',
  component: SelectBoxDropdownPreview,
}, {
  type: 'sizebox',
  component: SizeBoxDropdownPreview,
}, {
  type: 'text',
  component: TextBoxDropdownPreview,
}, {
  type: 'tag',
  component: TagsDropdownPreview,
}, {
  type: 'imageselect',
  component: ImageSelectDropdownPreview,
}, {
  type: 'rangeinput',
  component: RangeInputDropdownPreview,
}, {
  type: 'scrollbox',
  component: ScrollTabDropdownPreview,
}, {
  type: 'colorbox',
  component: ColorBoxDropdownPreview,
}, {
  type: 'combobox',
  component: ComboBoxDropdownPreview,
}, {
  type: 'map',
  component: MapFielddropdownPreview,
}, {
  type: 'reset',
  component: ResetButtonDropdownPreview,
}, {
  type: 'daterange',
  component: DateRangePickerDropdownPreview,
}, {
  type: 'sidebar',
  component: SideBarDropdownPreview,
}, {
  type: 'mapsearch',
  component: MapFielddropdownPreview,
}, {
  type: 'linearcheckbox',
  component: linearcheckboxdroppreview,
}, {
  type: 'rnb-daterange',
  component: RnbDatePickerDropDownPreview,
});

function showMarker(post) {
  let content;
  if (post.thumb_url) {
    content = '<div class="map-marker-custom"><div class="marker-content"><div class="marker-img"><img src="' + post.thumb_url + '" /></div><div class="marker-info"> <h4><a href=" ' + post.post_link + ' "> ' + post.post_title + '</a></h4>' + post.wow.slice(0, 50) + '</div></div></div>';
  } else {
    content = '<div class="my-location"><h4>' + post.post_title + '</h4></div>';
  }
  return content;
}
ReactiveMarkerTemplate['default'] = showMarker;
ReactiveMarkerTemplate['light'] = showMarker;


function showIcon(post) {
  // its also possible to show different icon based marker.
  return '<div class="pin"></div><div class="pulse"></div>';
}

function showDefaultIcon(post) {
  return '<div class="pin-alt"></div>';
}

ReactiveMarkerIcon['default'] = showDefaultIcon;
ReactiveMarkerIcon['shadow'] = showIcon;


ReactiveCategoryTemplate['default'] = 'showCategoryTemplate';
ReactiveCategoryTemplate['second'] = 'showCategoryTemplateTwo';
ReactiveCategoryTemplate['three'] = 'showCategoryTemplateThree';




/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/themes/reactiveTheme.js
 **/